export default __webpack_public_path__ + "static/media/logo.e99a4b35.png";